"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shortFormAddressComponentValidation = exports.getAddressComponentValidationRules = exports.defaultAddressComponentValidation = void 0;
var defaultAddressComponentValidation = {
  address: {
    firstLine: {
      required: true,
      maxLength: 254,
      title: true
    },
    secondLine: {
      required: false,
      maxLength: 254,
      title: true
    },
    city: {
      required: true,
      maxLength: 254,
      city: true
    },
    state: {
      required: true
    },
    zipCode: {
      required: true,
      maxLength: 5,
      pattern: 'postalCode'
    }
  }
};
exports.defaultAddressComponentValidation = defaultAddressComponentValidation;
var shortFormAddressComponentValidation = {
  address: {
    firstLine: {
      required: true,
      maxLength: 254,
      title: true
    },
    city: {
      required: true,
      maxLength: 254,
      city: true
    },
    zipCode: {
      required: true,
      maxLength: 5,
      pattern: 'postalCode'
    }
  }
};
exports.shortFormAddressComponentValidation = shortFormAddressComponentValidation;

var getAddressComponentValidationRules = function getAddressComponentValidationRules() {
  var usingShortFormRules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return usingShortFormRules ? shortFormAddressComponentValidation : defaultAddressComponentValidation;
};

exports.getAddressComponentValidationRules = getAddressComponentValidationRules;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/addresscomponent/addressComponentValidation.js
// module id = 4290
// module chunks = 9